export default "__VITE_ASSET__DZ80KO9t__"